export default __webpack_public_path__ + "static/media/category_25.dd9b82bb.png";